<template>
  <div>
    <el-table
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :data="tableData"
      border
      style="width: 100%;margin-top: 10px"
      @row-dblclick="handleClickdisplay"
    >
      <el-table-column prop="sid" label="序号" width="60" v-if="false">
      </el-table-column>
      <el-table-column prop="JobNo" label="单号" width="220"> </el-table-column>
      <el-table-column prop="sCustomerName" label="客户名称" width="800">
      </el-table-column>
      <el-table-column prop="sCREATEDATE" label="订单时间" width="200">
      </el-table-column>
      <el-table-column
        prop="sorderState"
        label="订单状态"
        width="80"
        v-if="false"
      >
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            @click="handleClickdisplay(scope.row)"
            type="text"
            size="small"
            v-show="bedit"
            >查看</el-button
          >
          <!-- <el-button
            @click="handleClickedit(scope.row)"
            type="text"
            size="small"
            v-show="bedit"
          >作废</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px; margin-bottom: 30px">
      <el-button @click="onmyexport()">导出EXCEL</el-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import global from "../global.vue";
import AES from "../AES.js";
// import XLSX from "../../public/xlsx.full.min.js";
import XLSX from "xlsx";

export default {
  data() {
    return {
      loading: false,
      sexceldownfilename: "orderlist.xlsx",
      slogid: "",
      sfilter: "",
      bedit: true,
      bbrow: false,
      tableData: [],
    };
  },
  created() {
    this.getdata();
  },
  mounted() {},
  methods: {
    onmyexport: function () {
      let tableDataExcel = [
        ["单号", "客户名称"], //导出表头
      ]; // 表格表头

      this.tableData.forEach((item, index) => {
        let rowData = [];
        //导出内容的字段
        rowData = [item.JobNo, item.sCustomerName];
        tableDataExcel.push(rowData);
      });

      //根据传参jdata和sfilename输出
      var wsname = "orderlistdata";
      // var ws = XLSX.utils.json_to_sheet(this.tableData);
      var ws = XLSX.utils.aoa_to_sheet(tableDataExcel);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, wsname);
      XLSX.writeFile(wb, this.sexceldownfilename);
    },

    handleClickdisplay(row) {
      this.$router.push({
        path: "/qtindex/orderdetail",
        query: { jobno: row.JobNo },
      });
    },
    getdata() {
      // var str = window.localStorage.getItem("douttime");
      // var douttimedec = AES.decrypt(str, global.AEScode);
      // console.log(douttimedec);
      // if (typeof douttimedec == "undefined") {
      //   alert("认证超时过期，或未认证");
      //   this.$router.replace("/");
      // } else {
      //   var myDate = new Date();
      //   if (douttimedec > myDate) {
      this.loading = true;

      let that = this;
      var stoken = window.localStorage.getItem("stoken");
      console.log(stoken);
      // axios.defaults.headers.common["token"] = stoken;
      axios({
        headers: {
          "Content-type": "text/xml",
          token: stoken,
        },
        method: "post",
        url: global.sserverip + "getorderlistbyscustomerid",
        data: stoken,
      })
        .then(function (res) {
          //TO-DO 先判断下数据是否正确 status
          that.tableData = res.data;
          that.loading = false;
        })
        .catch(function (err) {
          console.log(err);
          that.loading = false;
        });
      //   } else {
      //     alert("认证超时过期");
      //     this.$router.replace("/");
      //   }
      // }
    },
  },
};
</script>


